"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMenu = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const react_2 = require("@headlessui/react");
const MenuOverlay_1 = require("../MenuOverlay");
const classnames_1 = __importDefault(require("classnames"));
function AccountMenu(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const accountMenuWrapperRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", { ref: accountMenuWrapperRef },
        react_1.default.createElement(react_2.Menu, Object.assign({ as: "div", className: (0, classnames_1.default)('relative flex justify-center items-center top-px', className) }, props), ({ open }) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                children,
                (accountMenuWrapperRef === null || accountMenuWrapperRef === void 0 ? void 0 : accountMenuWrapperRef.current) &&
                    (0, react_dom_1.createPortal)(react_1.default.createElement(MenuOverlay_1.MenuOverlay, { open: open }), accountMenuWrapperRef.current)));
        })));
}
exports.AccountMenu = AccountMenu;
